import React, { useState, useMemo, useEffect } from "react";
import { useHistory } from "react-router-dom";
import useEventStore from "../../../../Store/EventStore.jsx";
import EventList from "./EventList.jsx";
import ConfirmationDialog from "../../../ui/ConfirmationDialog.jsx";
import CreateButton from "../molecules/CreateButton.jsx";
import NewEventForm from "../../../Product/NewEventForm.jsx";
import FeaturedEventsComponent from "../FeaturedEvents/FeaturedEventsComponent.jsx";
import { useTranslation } from "react-i18next";

function EventPage() {
  const { t } = useTranslation();
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [sortBy, setSortBy] = useState("eventDate");
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [eventToDelete, setEventToDelete] = useState("");
  const [type, setType] = useState("");
  const [newEventIsOpen, setNewEventIsOpen] = useState(false);
  const history = useHistory();

  const {
    fetchEvents,
    handleDeletingEventsOrSpaces,
    events,
    spaces,
    selectEvent,
    fetchFeaturedEvents,
    featuredEvents,
  } = useEventStore();

  useEffect(() => {
    fetchEvents();
    fetchFeaturedEvents();
  }, [fetchEvents, fetchFeaturedEvents]);

  const filteredEvents = useMemo(() => {
    let filtered = [...events];
    if (selectedCategory !== "all") {
      filtered = filtered.filter(
        (event) => event.category === selectedCategory
      );
    }
    filtered = filtered.sort((a, b) => {
      if (sortBy === "eventDate") {
        return new Date(a.eventDate) - new Date(b.eventDate);
      } else if (sortBy === "popularity") {
        return (b.featured ? 1 : 0) - (a.featured ? 1 : 0);
      }
      return 0;
    });
    return filtered;
  }, [events, selectedCategory, sortBy]);

  const featuredFilterEvent = featuredEvents.filter(
    (event) =>
      !events.some((e) => e.eventName === event.eventName) &&
      new Date(event.eventDate) >= new Date()
  );

  const handleDeleteClick = (type, name) => {
    setEventToDelete(name);
    setType(type);
    setIsPopupVisible(true);
  };

  const handleConfirm = () => {
    handleDeletingEventsOrSpaces(type, eventToDelete);
    setIsPopupVisible(false);
  };

  const handleCancel = () => {
    setIsPopupVisible(false);
  };

  const handleRedirect = (type, giftID, eventName) => {
    selectEvent(type, eventName);
    history.push(`/${type}/${eventName}`);
  };

  return (
    <div className="flex flex-col min-h-dvh bg-grey-500">
      <main>
        <FeaturedEventsComponent events={featuredFilterEvent} />

        <div className="flex flex-col gap-8 mt-8 ">
          <EventList
            events={filteredEvents}
            handleDeleteClick={handleDeleteClick}
            handleRedirect={handleRedirect}
          />

          <CreateButton
            label={t("create_event")}
            isOpen={newEventIsOpen}
            onOpen={() => setNewEventIsOpen(true)}
            onClose={() => setNewEventIsOpen(false)}
          >
            <NewEventForm
              setNewEventIsOpen={setNewEventIsOpen}
              handleFetchEvents={fetchEvents}
            />
          </CreateButton>

          <ConfirmationDialog
            isOpen={isPopupVisible}
            title={t("eventsAndSpaces.deleteEvent")}
            message={t("eventsAndSpaces.deleteConfirmMsg")}
            highlightText={eventToDelete}
            confirmText={t("common.delete")}
            cancelText={t("common.cancel")}
            subtitle={t("common.actionUndoneMsg")}
            onConfirm={handleConfirm}
            onCancel={handleCancel}
          />
        </div>
      </main>
    </div>
  );
}

export default EventPage;
